import * as React from "react";
const SvgCloseIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M19.777 4.222 4.221 19.778m.002-15.556 15.556 15.556" }));
export default SvgCloseIcon;
